angular.module('zc.projects')

.directive 'campaignEvents', ($q, $translate, CampaignStats, Devise, SearchFilter) ->
  campaign_event_statstrict: 'E'
  scope: {
    campaign: '='
    filters: '='
    campaignEventOrder: '='
    campaignEventNotices: '='
  }
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_events.html'

  link: (scope, element, attrs) ->
    scope.Devise = Devise
    scope.viewOptions =
      details: false
    scope.filters = SearchFilter.resolveFromLocation()
    SearchFilter.setComponentDefaults 'campaignEventsList',
      sort_prop:
        default: 'predefined'
      sort_direction:
        default: 'desc'

    scope.$on '$destroy', () ->
      SearchFilter.removeComponentDefaults('campaignEventsList')

    scope.setSortProp = (key) ->
      if scope.filters.sort_prop == key
        if scope.filters.sort_direction == 'desc'
          scope.filters.sort_direction = 'asc'
        else
          scope.filters.sort_direction = 'desc'
      else
        scope.filters.sort_prop = key
        scope.filters.sort_direction = 'desc'
      scope.updateData()

    setNotices = (campaign_events) ->
      notices = []
      for event in scope.campaign_events
        for notice in scope.campaignEventNotices
          continue unless event.id is notice.name
          is_notify = true
          message = event.name
          value = event.count
          unit = ''
          if notice.unit_type is 'percent'
            message += $translate.instant('projects.campaignsDirectivesCampaignEvents.no_wariai')
            value = value / scope.stats.experimental.delivery_count * 100
            unit = '%'
          message += $translate.instant('projects.campaignsDirectivesCampaignEvents.ga')
          for op in ['gte', 'lte', 'gt', 'lt', 'eq']
            if notice[op]
              switch op
                when 'gte'
                  match = notice.gte <= value
                  msg = $translate.instant('projects.campaignsDirectivesCampaignEvents.ijou', { op: "#{notice.gte}#{unit}" })
                when 'lte'
                  match = notice.lte >= value
                  msg = $translate.instant('projects.campaignsDirectivesCampaignEvents.ika', { op: "#{notice.lte}#{unit}" })
                when 'gt'
                  match = notice.gt < value
                  msg = $translate.instant('projects.campaignsDirectivesCampaignEvents.wo_chouka', { op: "#{notice.gt}#{unit}" })
                when 'lt'
                  match = notice.lt > value
                  msg = $translate.instant('projects.campaignsDirectivesCampaignEvents.miman', { op: "#{notice.lt}#{unit}" })
                when 'eq'
                  match = notice.eq is value
                  msg = $translate.instant('projects.campaignsDirectivesCampaignEvents.to_douchi', { op: "#{notice.eq}#{unit}" })
              if match
                message += msg
              else
                is_notify = false
          message += $translate.instant('projects.campaignsDirectivesCampaignEvents.ninatteimasu')
          notices.push message if is_notify
      notices

    scope.updateData = ->
      $q.all [
        CampaignStats.getCampaignEventStats
          apikey: scope.campaign.apikey
          campaign_id: scope.campaign.id
          element_id: scope.campaign.element.id
          dimension: 'hourly'
          start_at: scope.filters.start_at
          end_at: moment(scope.filters.end_at).endOf('day').valueOf()
        CampaignStats.aggregate
          dimension: 'daily'
          campaign_id: scope.campaign.id
          apikey: scope.campaign.apikey
          start_at: scope.filters.start_at
          end_at: moment(scope.filters.end_at).endOf('day').valueOf()
      ]
      .then ([campaign_event_stats, campaign_stats]) ->
        campaign_event_stat_by_id = {}
        scope.campaign_events = []
        scope.campaign_events_by_id = {}
        scope.campaign_events_action = {}
        for campaign_event_stat in campaign_event_stats
          campaign_event_stat.conversion_rate = if campaign_event_stat.count > 0 then 100 * campaign_event_stat.conversion_count  / campaign_event_stat.count else 0
          if _.endsWith(campaign_event_stat._id, '_click')
            name = campaign_event_stat._id.replace('_click', '')
            scope.campaign_events_action[name] = {} if !scope.campaign_events_action[name]
            scope.campaign_events_action[name]['click'] = campaign_event_stat.count
          else if _.endsWith(campaign_event_stat._id, '_hover')
            name = campaign_event_stat._id.replace('_hover', '')
            scope.campaign_events_action[name] = {} if !scope.campaign_events_action[name]
            scope.campaign_events_action[name]['hover'] = campaign_event_stat.count
          else if _.endsWith(campaign_event_stat._id, '_hold')
            name = campaign_event_stat._id.replace('_hold', '')
            scope.campaign_events_action[name] = {} if !scope.campaign_events_action[name]
            scope.campaign_events_action[name]['hold'] = campaign_event_stat.count
          else if _.endsWith(campaign_event_stat._id, '_show')
            name = campaign_event_stat._id.replace('_show', '')
            scope.campaign_events_action[name] = {} if !scope.campaign_events_action[name]
            scope.campaign_events_action[name]['show'] = campaign_event_stat.count
          else
            campaign_event_stat_by_id[campaign_event_stat._id] = campaign_event_stat

        for eventOrder in scope.campaignEventOrder
          for id, name of eventOrder
            campaign_event_stat = campaign_event_stat_by_id[id]
            if campaign_event_stat
              campaign_event_stat.id = id
              delete campaign_event_stat_by_id[id]
              campaign_event_stat.name = name
              scope.campaign_events.push campaign_event_stat
        for id, campaign_event_stat of campaign_event_stat_by_id
          campaign_event_stat.name = id
          scope.campaign_events.push campaign_event_stat
        if scope.filters.sort_prop isnt 'predefined'
          scope.campaign_events = _.sortBy(scope.campaign_events, scope.filters.sort_prop)
          if scope.filters.sort_direction == 'desc'
            scope.campaign_events.reverse()

        for campaign_event in scope.campaign_events
          scope.campaign_events_by_id[campaign_event.id] = campaign_event

        scope.stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id]

        scope.notices = setNotices scope.campaign_events

    scope.$watch 'filters', scope.updateData, true



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_events.coffee